<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Edit Organization
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="formData.name"
                  label="Organization Name*"
                  hint="Name for your reference - 'DBSystems'."
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="formData.organizationType"
                  menu-props="auto"
                  :items="organizations"
                  item-text="id"
                  item-value="value"
                  label="Organization Type*"
                  prepend-icon="mdi-domain"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="formData.organizationCategory"
                  menu-props="auto"
                  :items="organizationCategories"
                  item-text="id"
                  item-value="value"
                  label="Organization Category*"
                  prepend-icon="mdi-domain"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <address-form
                  ref="addressForm"
                  @addressEntered="assiginAddress($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="formData.phoneNumber"
                  label="Phone-Number"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="formData.officeTimeZone"
                  menu-props="auto"
                  :items="timeZonesByName"
                  label="Time Zone*"
                  prepend-icon="mdi-clipboard-text-clock-outline"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="formData.alias"
                  label="Alias"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="formData.externalId"
                  label="Organization-Id"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="formData.taxId"
                  menu-props="auto"
                  :items="taxRates"
                  :item-text="showText"
                  item-value="id"
                  label="Tax Type*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-form>
          <br>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="$router.push({ name: 'Organizations' })"
          >
            Back
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="submit()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
      <br>
    </v-card>
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import AddressForm from 'src/views/dashboard/component/AddressForm';

  export default {
    name: 'EditOrganization',
    components: {
      'centre-spinner': spinner,
      'address-form': AddressForm,
    },
    data () {
      return {
        organizations: [{ id: 'Church', value: 'church' }, { id: 'Shopping Centre', value: 'shoppingCentre' }, { id: 'Construction', value: 'construction' }, { id: 'Restaurants', value: 'restaurants' }, { id: 'Dental', value: 'dental' }],
        valid: false,
        loading: false,
        organizationCategories: [{ id: 'Host', value: 'host' }, { id: 'Advertiser', value: 'advertiser' }],
        formData: {
          name: '',
          organizationType: '',
          phoneNumber: null,
          officeTimeZone: '',
          alias: null,
          externalId: '',
          address: {},
          taxId: null,
          organizationCategory: '',
        },
      };
    },
    computed: {
      organizationDetails () {
        return this.$store.getters['organizations/getOrganizationDetails'];
      },
      taxRates () {
        return this.$store.getters['payments/getTaxRates'];
      },
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
      allTimeZones () {
        return this.$store.getters['users/getTimeZones'];
      },
      timeZonesByName () {
        return Object.keys(this.allTimeZones).map((key) => ({ text: key, value: this.allTimeZones[key] }));
      },
    },
    async mounted () {
      await this.FetchOrganizationDetails();
      this.fillData();
      this.fetchTaxRates();
      this.getCountryCodes();
      this.getAllTimeZone();
    },
    methods: {
      fillData () {
        this.formData.name = this.organizationDetails.name;
        this.formData.organizationType = this.organizationDetails.type;
        this.formData.phoneNumber = this.organizationDetails.phone_number;
        this.formData.officeTimeZone = this.organizationDetails.office_timezone;
        this.formData.alias = this.organizationDetails.alias;
        this.formData.externalId = this.organizationDetails.external_id;
        this.formData.taxId = this.organizationDetails.tax_id;
        this.formData.organizationCategory = this.organizationDetails.category;
        if (this.organizationDetails.address !== null) {
          this.$refs.addressForm.fillData(this.organizationDetails.address);
        }
      },
      submit () {
        this.$refs.addressForm.getEnteredAdress();
        if (this.$refs.form.validate() === false || Object.keys(this.formData.address).length === 0) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (Object.keys(this.formData.address).length > 0) {
          this.loading = true;
          this.$store.dispatch('organizations/updateOrganization', {
            editOrganizationDetails: {
              name: this.formData.name,
              type: this.formData.organizationType,
              timezone: this.formData.officeTimeZone,
              address: this.formData.address,
              phone_number: this.formData.phoneNumber,
              tax_id: this.formData.taxId,
              category: this.formData.organizationCategory,
            },
            organizationId: this.$route.params.organizationId,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Organization updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.formData.address = {};
            this.loading = false;
            this.$router.push({ name: 'Organizations' });
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      assiginAddress (address) {
        this.formData.address = address;
      },
      async FetchOrganizationDetails () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchOrganizationDetails', {
          organizationId: this.$route.params.organizationId,
        });
        this.loading = false;
      },
      fetchTaxRates () {
        this.$store.dispatch('payments/fetchTaxRates');
      },
      getCountryCodes () {
        this.$store.dispatch('users/fetchCountryCodes');
      },
      showText (item) {
        return `${item.name} - ${this.CountryCodeList[item.country]}`;
      },
      getAllTimeZone () {
        this.$store.dispatch('users/fetchTimeZones');
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
</style>
